export default {
  export: 'Download',
  export_condition: 'Download Per Condition',
  export_sku: 'Download Per SKU',
  export_history: 'Download History',
};
